module.exports = __webpack_public_path__ + "static/media/strongher@2x.25dc8af9.jpg";